/** @namespace ShopifyCustomer/Api/Customer/Processor/processCustomer */
export const processCustomer = () => {};
